<template lang="pug">
  section.v-panel(:class='classes')
    header.v-panel__header(
      v-if='$slots.header'
      :id='activatorId'
      :aria-controls='contentId'
      :tabindex='collapsible ? 0 : null'
      v-a11y-interactive='collapsible ? toggleCollapsed : null'
    )
      .header__collapse(v-if='collapsible')
        | {{ isCollapsed ? '&#9658' : '&#9660' }}
      slot(name='header')
    .v-panel__content(
      :id='contentId'
      :aria-labelledby='activatorId'
      :aria-expanded='collapsible ? showBody ? "true" : "false" : null'
    )
      slot(v-if='showBody')
</template>

<script>
import UIDMixin from '@/mixins/uid'

export default {
  name: 'content-box',
  mixins: [
    UIDMixin,
  ],
  props: {
    color: {
      type: String,
      default: 'blue'
    },
    collapsible: {
      type: Boolean,
      default: false
    },
    initCollapsed: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isCollapsed: !!this.initCollapsed
    }
  },
  computed: {
    activatorId () {
      if (!this.collapsible) return null
      return 'v-panel__activator_' + this.uid
    },
    contentId () {
      if (!this.collapsible) return null
      return 'v-panel__content_' + this.uid
    },
    classes () {
      return [
        'v-panel--' + this.color,
        this.collapsible ? 'v-panel--collapsible' : null
      ]
    },
    showBody () {
      return !this.collapsible || !this.isCollapsed
    }
  },
  methods: {
    toggleCollapsed () {
      this.isCollapsed = !this.isCollapsed
    }
  }
}
</script>

<style lang="scss">
@import 'src/assets/styles/colors';

/* This uses BEM naming conventions instead of css modules */
.v-panel {
  $block: &;

  > #{$block}__header {
    color: #FFFFFF;
    padding: 5px 0.5rem;
    font-weight: bold;

    > .header__collapse {
      margin: 0 0.5rem 0 0;
      display: inline-block;
      // float: right;
    }
  }

  > #{$block}__content {
    padding: 0.1rem 0.5rem;

    &[aria-expanded=false] {
      display: none;
    }
  }

  &--blue {
    background-color: map-deep-get($base-theme, bg, secondary, light);
    border: 1px solid map-deep-get($base-theme, bg, secondary, dark);

    & > #{$block}__header {
      background-color: map-deep-get($base-theme, bg, secondary, dark);
      border-bottom: 1px solid map-deep-get($base-theme, bg, secondary, dark);
    }
  }

  &--green {
    background-color: map-deep-get($base-theme, bg, primary, light);
    border: 1px solid map-deep-get($base-theme, bg, primary, dark);

    & > #{$block}__header {
      background-color: map-deep-get($base-theme, bg, primary, dark);
      border-bottom: 1px solid map-deep-get($base-theme, bg, primary, dark);
    }
  }

  &--collapsible {
    > #{$block}__header {
      cursor: pointer;
    }
  }

}
</style>
